import React, { useCallback, useState } from "react";
import { Box } from "orcs-design-system";
import styled from "styled-components";
import { get } from "lodash";
import NodeVisualizer from "src/components/NodeVisualizer";
import { useOrgChartContext } from "../../context/OrgChartContext";
import { useOrgChartNodesAndEdges } from "../../hooks/useOrgChartNodesAndEdges";
import OrgChatPanel from "../OrgChartPanel";

const Container = styled(Box)`
  height: 800px;
`;

const TeamVisualiser = () => {
  const { data, loading, state } = useOrgChartContext();
  const [initialFitViewTriggered, setInitialFitViewTriggered] = useState(false);

  const { nodes, edges } = useOrgChartNodesAndEdges({ data, state });

  const afterLayout = useCallback(
    ({ reactFlow, nodes: layoutedNodes }) => {
      if (initialFitViewTriggered) {
        return;
      }

      setInitialFitViewTriggered(true);

      const currentViewNode = layoutedNodes.find(
        (n) => n.id === state.currentViewTeam?.id
      );

      setTimeout(() => {
        const paneRects = document
          .querySelector(".react-flow__renderer")
          .getBoundingClientRect();

        reactFlow.setViewport(
          {
            zoom: 0.7,
            y: -30,
            x: paneRects.width / 2 - get(currentViewNode, "width", 400) / 2,
          },
          { duration: 500 }
        );
      }, 100);
    },
    [initialFitViewTriggered, state.currentViewTeam]
  );

  return (
    <Container>
      <NodeVisualizer
        loading={loading}
        initialNodes={nodes}
        initialEdges={edges}
        afterLayout={afterLayout}
        noWheelZoom
        animatedNodesEnabled
      >
        <OrgChatPanel />
      </NodeVisualizer>
    </Container>
  );
};

export default React.memo(TeamVisualiser);
